export default class MURL
{
	constructor(url, params)
	{
		this.url = url;
		this.params = params;
	}

	toString()
	{
		let url = this.url;
		let paramsString = (new URLSearchParams(this.params)).toString();

		if (paramsString.length) {
			url += `?${paramsString}`;
		}

		return url;
	}
}
